"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadTrimmedSignature = exports.deleteFile = exports.uploadFile = void 0;
var supabaseClient_1 = require("./supabaseClient");
/**
 * Uploads a file to Supabase Storage
 * @param file The file to be uploaded
 * @param path The path in the bucket where the file will be stored (e.g., "user-images/image.png")
 * @returns The public URL of the uploaded file or an error message
 */
var uploadFile = function (file, bucket, path) { return __awaiter(void 0, void 0, void 0, function () {
    var error, signedUrlData, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, supabaseClient_1.supabase.storage.from(bucket).upload(path, file)];
            case 1:
                error = (_a.sent()).error;
                if (error)
                    throw error;
                return [4 /*yield*/, supabaseClient_1.supabase.storage
                        .from(bucket)
                        .getPublicUrl(path)];
            case 2:
                signedUrlData = (_a.sent()).data;
                return [2 /*return*/, signedUrlData.publicUrl];
            case 3:
                error_1 = _a.sent();
                console.error("Error uploading file:", error_1.message);
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.uploadFile = uploadFile;
var deleteFile = function (path) { return __awaiter(void 0, void 0, void 0, function () {
    var error, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, supabaseClient_1.supabase.storage.from("uploads").remove([path])];
            case 1:
                error = (_a.sent()).error;
                if (error)
                    throw error;
                console.log("File at ".concat(path, " successfully deleted."));
                return [2 /*return*/, true];
            case 2:
                error_2 = _a.sent();
                console.error("Error deleting file:", error_2.message);
                throw error_2;
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.deleteFile = deleteFile;
var uploadTrimmedSignature = function (trimmedDataURL, path) { return __awaiter(void 0, void 0, void 0, function () {
    var response, blob, uploadError, publicUrlData, downloadURL, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4 /*yield*/, fetch(trimmedDataURL)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.blob()];
            case 2:
                blob = _a.sent();
                return [4 /*yield*/, supabaseClient_1.supabase.storage
                        .from("uploads")
                        .upload(path, blob, {
                        contentType: "image/png", // Set the MIME type based on your data URL
                    })];
            case 3:
                uploadError = (_a.sent()).error;
                if (uploadError) {
                    throw new Error(uploadError.message);
                }
                publicUrlData = supabaseClient_1.supabase.storage
                    .from("uploads")
                    .getPublicUrl(path).data;
                downloadURL = publicUrlData.publicUrl;
                return [2 /*return*/, downloadURL];
            case 4:
                error_3 = _a.sent();
                console.error("Error saving signature:", error_3.message);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.uploadTrimmedSignature = uploadTrimmedSignature;
